import {
  FilterChipsRow as UiFilterChipsRow,
  type FilterChipsRowProps,
} from '../index';

import { useTheme } from './theme';

// Thin mount of the SHARED @heraion/ui FilterChipsRow (lifted with the
// Add-Exercise picker, P2): injects the mobile theme so CatalogScreen and
// ExerciseSwapPicker keep their import + call shape unchanged.
export function FilterChipsRow<T extends string>(
  props: Omit<FilterChipsRowProps<T>, 'theme'>,
) {
  const theme = useTheme();
  return <UiFilterChipsRow {...props} theme={theme} />;
}
